import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { ErrorHandlingService } from '../error-handling/error-handling.service';
import { SpinnerService } from '../spinner';
import { ValidationEntityType } from '../../models/netsuite/validation-entity-type.model';
import { HttpHeaderConstants } from '../http-header.constant';
import { catchError, finalize, retry } from 'rxjs/operators';
import { NetsuiteConnection } from '../../models/appcloud/netsuite/netsuite-connection.model';
import { Field } from '../../models/appcloud/netsuite/netsuite-entity.model';

@Injectable({
    providedIn: 'root',
})
export class NetsuiteCustomFieldService {
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);
    readonly #errorHandlingService = inject(ErrorHandlingService);

    private CUSTOM_FIELDS_URL: string = environment.publicApiHost + '/netsuite/fields/custom/';

    getCustomFields(
        type: ValidationEntityType,
        connection: NetsuiteConnection,
        additionalHeaders: any = {}
    ): Observable<Field[]> {
        this.#spinnerService.addProcess(
            'NetsuiteCustomFieldService.getCustomFields.' + type,
            'Fetching ' + type.toLowerCase().replace('_', ' ') + ' Custom Fields...'
        );

        const customHttpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
            params: new HttpParams(),
        };

        return this.#http.post<Field[]>(this.CUSTOM_FIELDS_URL + type, connection, customHttpOptions).pipe(
            retry(0),
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while trying to fetcb your Netsuite Custom Fields. Please try again later.'
                );
                return of<Field[]>();
            }),
            finalize(() => this.#spinnerService.completeProcess('NetsuiteCustomFieldService.getCustomFields.' + type))
        );
    }
}
